import HttpClient from '@/utils/HttpClient';
import projectStore from '@/store/Projects';
import utils from '@/utils/formatting';

export default {
  getAll() {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/risks`);
  },
  getAllVE() {
    return new Promise((resolve, reject) => {
      return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/risks/ve`)
        .then(result => {
          result.forEach(element => {
            element.BudgetSaldo = parseFloat(element.BudgetSaldo);
            element.LVPreis = element.LVPreis ? parseFloat(element.LVPreis) : 0;
            element.LVPreisAbw = element.LVPreisAbw ? parseFloat(element.LVPreisAbw) : 0;
            element.ActiveQuoteAmount = element.ActiveQuoteAmount ? parseFloat(element.ActiveQuoteAmount) : 0;
            element.APAbw = element.APAbw ? parseFloat(element.APAbw) : 0;
            element.AmountSaldo = element.AmountSaldo ? parseFloat(element.AmountSaldo) : 0;
            element.Chancen = element.Chancen ? parseFloat(element.Chancen) : 0;
            element.ChancenPrognose = element.ChancenPrognose ? parseFloat(element.ChancenPrognose) : 0;
            element.Risiken = element.Risiken ? parseFloat(element.Risiken) : 0;
            element.RisikenPrognose = element.RisikenPrognose ? parseFloat(element.RisikenPrognose) : 0;
            element.Total = element.Total ? parseFloat(element.Total) : 0;
            element.TotalPrognose = element.TotalPrognose ? parseFloat(element.TotalPrognose) : 0;
            element.LVPreisAbw = element.BudgetSaldo - element.LVPreis;
            element.APAbw = element.BudgetSaldo - element.ActiveQuoteAmount;
            element.CnRActive = element.CnRActive == 'true' ? true : false;
            element.Total = element.Risiken - element.Chancen;
            element.TotalPrognose = element.RisikenPrognose - element.ChancenPrognose;
          });
          resolve(result);
        })
        .catch(err => reject(err));
    });
  },
  getAllProject() {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/risks/project`);
  },
  getCnRsByVeId(veDbId) {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/risks/ve/${veDbId}`);
  },
  getCnRById(rid) {
    return new Promise((resolve, reject) => {
      return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/risks/${rid}`)
        .then(result => {
          result.Datum = utils.SQLDateToBrowserDate(result.Datum);
          resolve(result);
        })
        .catch(err => reject(err));
    });
  },
  getVESummary(veDbId) {
    return new Promise((resolve, reject) => {
      return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/risks/ve/${veDbId}/summary`)
        .then(result => {
          result.LVPreisAbw = result.BudgetSaldo - result.LVPreis;
          result.APAbw = result.BudgetSaldo - result.ActiveQuoteAmount;
          result.NachtragsBudget = result.BudgetSaldo - result.AmountSaldo;
          result.Obligo = result.AmountSaldo - result.Invoiced;
          resolve(result);
        })
        .catch(err => reject(err));
    });
  },
  create(risk) {
    risk.Datum = utils.browserDateToSQLDate(risk.Datum);
    return HttpClient.postAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/risks`, {
      risk: risk
    });
  },

  update(risk) {
    risk.Datum = utils.browserDateToSQLDate(risk.Datum);
    return HttpClient.updateAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/risks/${risk.DbId}`, {
      risk: risk
    });
  },

  updateCnRActiveFlag(ve) {
    return HttpClient.postAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/risks/ve/${ve.VeDbId}/active`,
      { active: ve.CnRActive }
    );
  },

  delete(risk) {
    return HttpClient.deleteAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/risks/${risk.DbId}`);
  },

  getProjectSummary() {
    return new Promise((resolve, reject) => {
      return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/risks/summary`)
        .then(result => {
          result.TotalChancen = result.TotalVEChancen + result.TotalProjectChancen;
          result.TotalChancenP = result.TotalVEChancenP + result.TotalProjectChancenP;
          result.TotalRisiken = result.TotalVERisiken + result.TotalProjectRisiken;
          result.TotalRisikenP = result.TotalVERisikenP + result.TotalProjectRisikenP;
          result.TotalVE = result.TotalVERisiken - result.TotalVEChancen;
          result.TotalVEP = result.TotalVERisikenP - result.TotalVEChancenP;
          result.TotalProject = result.TotalProjectRisiken - result.TotalProjectChancen;
          result.TotalProjectP = result.TotalProjectRisikenP - result.TotalProjectChancenP;
          result.Total = result.TotalVE + result.TotalProject;
          result.TotalP = result.TotalVEP + result.TotalProjectP;
          resolve(result);
        })
        .catch(err => reject(err));
    });
  }
};
